import React from 'react';
import { useHistory } from 'react-router';
import { HistoryBreadcrumb, useStatusChanges } from '../../Agreement/Components/AgreementHistoryBreadcrumb';
import { useToolTipContext } from '../../Agreement/Components/AgreementHistoryBreadcrumbToolTip';
import AgreementStatusChangeModal from '../../Agreement/Modals/AgreementStatusChangeModal';
import { useAgreementAuditStore } from '../../Agreement/Provider/useAgreementAuditStore';
import { useStatusChangeButtons } from '../../Agreement/Provider/useStatusChangeButtons';
import ActionButton from '../../common/ActionButtons/ActionButton';
import AddendumStatusChangeReason from '../Forms/AddendumStatusChangeForm';
import { useAddendaStore } from '../Provider/useAddendaStore';

function StatusChangeButton({
    permission,
    modalTitle,
    statusFrom,
    statusTo,
    buttonClass,
    buttonText,
    evidenceMandatory,
    helpText,
    afterChange,
    open,
    close
}) {
    const { setTooltipOpen, setTooltipClosed } = useToolTipContext();
    const disabledReason =
        permission.disabledReason ?? (!permission.isEnabled ? 'Not available at this stage.' : undefined);

    return (
        <ActionButton
            bootstrapColor="secondary"
            buttonClass={buttonClass}
            buttonText={buttonText}
            disabled={!!disabledReason}
            fontawesomeIcon="fa-plus"
            onClickAction={() =>
                open(
                    modalTitle,
                    <AddendumStatusChangeReason
                        afterChange={afterChange}
                        buttonText={buttonText}
                        cancel={() => close()}
                        evidenceMandatory={evidenceMandatory}
                        helpText={helpText}
                        statusFrom={statusFrom}
                        statusTo={statusTo}
                    />
                )
            }
            onMouseEnter={() => {
                if (disabledReason) {
                    setTooltipOpen(<div>{disabledReason}</div>);
                }
            }}
            onMouseLeave={() => setTooltipClosed()}
            title={disabledReason}
        />
    );
}

function StatusChangeButtons({ workflow, statusFrom }) {
    const history = useHistory();
    const statusChangeButtons = useStatusChangeButtons(workflow, statusFrom);
    const afterChange = (newStatus) => {
        const goBackOnNewStatuses = ['DELT'];
        if (newStatus && goBackOnNewStatuses.includes(newStatus)) { 
            history.goBack();
        }
    }
    return (
        <AgreementStatusChangeModal>
            {({ open, close }) =>
                statusChangeButtons.length === 0 ? (
                    <li>
                        <div />
                    </li>
                ) : (
                    <li className="status-crumb-actions">
                        {statusChangeButtons.map(x => (
                            <StatusChangeButton
                                key={x.id}
                                {...x}
                                afterChange={afterChange}
                                buttonClass={`hover-pointer nowrap ml-3 ${
                                    x.buttonType === 'negative'
                                        ? 'btn btn-danger'
                                        : x.buttonType === 'positive'
                                        ? 'btn btn-success'
                                        : 'btn btn-info'
                                }`}
                                close={close}
                                open={open}
                                style={{ zIndex: 5000 }}
                            />
                        ))}
                    </li>
                )
            }
        </AgreementStatusChangeModal>
    );
}

export default function AgreementHistoryBreadcrumb() {
    const workflow = useAddendaStore(state => state.addendum?.workflow);
    const status = useAddendaStore(state => state.addendum?.status);
    const audits = useAgreementAuditStore(state => state.data);
    const statusChanges = useStatusChanges(audits, 'addendumStatus');
    return (
        <HistoryBreadcrumb statusChanges={statusChanges}>
            <StatusChangeButtons statusFrom={status} workflow={workflow} />
        </HistoryBreadcrumb>
    );
}
